/* eslint-disable global-require */
import React from 'react';
import { Icon } from '@mdi/react';
import PropTypes from 'prop-types';

const MDIcon = (props) => {
  const { iconPath, className, size, title } = props;
  const iconSet = require('@mdi/js');
  const solvedIcon = iconSet[iconPath];
  return solvedIcon ? (
    <Icon title={title} className={className} path={solvedIcon} size={size} />
  ) : null;
};

MDIcon.propTypes = {
  iconPath: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
};

MDIcon.defaultProps = {
  iconPath: '',
  className: 'default_icon_size',
  size: 1,
  title: '',
};

export default MDIcon;
